module.exports = __webpack_public_path__ + "static/media/unionpay.314f8cb8.svg";